import { render, staticRenderFns } from "./OSliderButton.vue?vue&type=template&id=d5a8dd34&"
import script from "./OSliderButton.vue?vue&type=script&lang=js&"
export * from "./OSliderButton.vue?vue&type=script&lang=js&"
import style0 from "./OSliderButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports